module.exports = __webpack_public_path__ + "static/media/schedules.437cb660.svg";